import appConfig from "@/app/utils/config";
import { getCookieValue, onUnAuthorizeLogoutHandle } from "@/app/utils/utility";
import axios from "axios";
import {
  hideLoader,
  showLoader,
} from "../redux/loading-management/loading-management-slice";
import { store } from "../redux/config/store";
import { showTermConditionModal } from "../redux/latest-version-modal-management/latest-version-modal-management-clice";
import { enqueueSnackbar } from "notistack";

const apiInstance = axios.create({
  baseURL: appConfig.APP_DEVELOPMENT_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});
apiInstance.interceptors.request.use(
  (config) => {
    const token = getCookieValue("accessToken");
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    if (!config?.skipLoader) {
      store.dispatch(showLoader()); // Show loader on request
    }
    return config;
  },
  (error) => {
    store.dispatch(hideLoader()); // Hide loader on error
    return Promise.reject(error);
  }
);

apiInstance.interceptors.response.use(
  (result) => {
    store.dispatch(hideLoader()); // Hide loader on response
    return Promise.resolve(result);
  },
  (error) => {
    store.dispatch(hideLoader()); // Hide loader on error
    if (getCookieValue("accessToken") && error?.response?.status === 401) {
      // onUnAuthorizeLogoutHandle();
    }
    // if (error?.response?.status === 428) {
    //   enqueueSnackbar(error?.response?.data?.message, {
    //     variant: "error",
    //     autoHideDuration: 2000,
    //   });
    //   store.dispatch(showTermConditionModal());
    // }
    if (error?.response?.status === 403) {
      return Promise.reject(error);
    }
    if (error?.response?.status === 322) {
      return Promise.reject(error);
    }
    return Promise.reject(error.response || error);
  }
);

export const apiInstance_ecom = axios.create({
  baseURL: appConfig.APP_DEVELOPMENT_URL_Ecom,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

apiInstance_ecom.interceptors.request.use(
  (config) => {
    const userType =
      getCookieValue("userType") ||
      store.getState().auth.userLoginDetails.user_type;
    if (userType === "Business")
      config.params = { ...config.params, userType: "Business" };
    const token = getCookieValue("accessToken");
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    if (!config?.skipLoader) {
      store.dispatch(showLoader()); // Show loader on request
    }
    return config;
  },
  (error) => {
    store.dispatch(hideLoader()); // Hide loader on error
    return Promise.reject(error);
  }
);

apiInstance_ecom.interceptors.response.use(
  (result) => {
    store.dispatch(hideLoader()); // Hide loader on response
    return Promise.resolve(result);
  },
  (error) => {
    store.dispatch(hideLoader()); // Hide loader on error
    if (getCookieValue("accessToken") && error?.response?.status === 401) {
      // onUnAuthorizeLogoutHandle();
    }
    // if (error?.response?.status === 428) {
    //   enqueueSnackbar(error?.response?.data?.message, {
    //     variant: "error",
    //     autoHideDuration: 2000,
    //   });
    //   store.dispatch(showTermConditionModal());
    // }
    if (error?.response?.status === 400) {
      return error;
    }
    if (error?.response?.status === 403) {
      return Promise.reject(error);
    }
    if (error?.response?.status === 322) {
      return Promise.reject(error);
    }
    return Promise.reject(error.response || error);
  }
);
// Used for File Upload
export const apiInstance1 = axios.create({
  baseURL: appConfig.APP_DEVELOPMENT_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

apiInstance1.interceptors.request.use(
  (config) => {
    const userType =
      getCookieValue("userType") ||
      store.getState().auth.userLoginDetails.user_type;
    if (userType === "Business")
      config.params = { ...config.params, userType: "Business" };
    const token = getCookieValue("accessToken");
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiInstance1.interceptors.response.use(
  (result) => {
    return Promise.resolve(result); // Return the AxiosResponse directly
  },
  (error) => {
    if (getCookieValue("accessToken") && error?.response?.status === 401) {
      // onUnAuthorizeLogoutHandle();
    }
    // if (error?.response?.status === 428) {
    //   enqueueSnackbar(error?.response?.data?.message, {
    //     variant: "error",
    //     autoHideDuration: 2000,
    //   });
    //   store.dispatch(showTermConditionModal());
    // }
    if (error?.response?.status === 403) {
      return Promise.reject(error);
    }
    if (error?.response?.status === 322) {
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);
export const apiInstance2 = axios.create({
  baseURL: appConfig.APP_DEVELOPMENT_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

apiInstance2.interceptors.request.use(
  (config) => {
    const userType =
      getCookieValue("userType") ||
      store.getState().auth.userLoginDetails.user_type;
    if (userType === "Business")
      config.params = { ...config.params, userType: "Business" };
    const token = getCookieValue("accessToken");
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiInstance2.interceptors.response.use(
  (result) => {
    return Promise.resolve(result); // Return the AxiosResponse directly
  },
  (error) => {
    if (getCookieValue("accessToken") && error?.response?.status === 401) {
      // onUnAuthorizeLogoutHandle();
    }
    // if (error?.response?.status === 428) {
    //   enqueueSnackbar(error?.response?.data?.message, {
    //     variant: "error",
    //     autoHideDuration: 2000,
    //   });
    //   store.dispatch(showTermConditionModal());
    // }
    if (error?.response?.status === 403) {
      return Promise.reject(error);
    }
    if (error?.response?.status === 322) {
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default apiInstance;

// global unprotected api instance
export const globalAPIInstance = axios.create({
  baseURL: appConfig.APP_DEVELOPMENT_URL_ERP,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

globalAPIInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.log(error, "erorr");
    return Promise.reject(error);
  }
);

globalAPIInstance.interceptors.response.use(
  (result) => {
    return Promise.resolve(result);
  },
  (error) => {
    if (getCookieValue("accessToken") && error?.response?.status === 401) {
      // onUnAuthorizeLogoutHandle();
    }
    // if (error?.response?.status === 428) {
    //   enqueueSnackbar(error?.response?.data?.message, {
    //     variant: "error",
    //     autoHideDuration: 2000,
    //   });
    //   store.dispatch(showTermConditionModal());
    // }
    return Promise.reject(error);
  }
);
